const { AbilityBuilder } = require("@casl/ability");

function defineAbilitiesFor(user) {
  const ability = AbilityBuilder.define(
    {
      subjectName: (subject) => {
        if (!subject || typeof subject === "string") {
          return subject;
        }
        return subject.subjectName;
      },
    },
    (can) => {
      if (user) {
        if (user.role === "admin") {
          can("manage", "all");
          can("approve", "person");
          can("redefinePassword", "person");
          can("activate", "person");
          can("inactivate", "person");

          can("viewDetails", "voucher");
        } else if (user.role === "ti") {
          can("read", "person");
          can("create", "person");
          can("update", "person");
          can("approve", "person");
          can("redefinePassword", "person");
          can("activate", "person");
          can("inactivate", "person");

          can("manage", "personHistory");

          can("manage", "voucher");
        } else if (user.role === "user") {
          can("read", "person");
          can("create", "person");
          can("update", "person");
          can("approve", "person");
          can("redefinePassword", "person");
          can("activate", "person");
          can("inactivate", "person");

          can("read", "voucher");
          can("create", "voucher");
          can("update", "voucher");
        } else if (user.role === "guest") {
          can("read", "person");
        }
      } else {
        can("read", "person");
      }
    }
  );

  return ability;
}

module.exports = defineAbilitiesFor;
